import { render, staticRenderFns } from "./exercise-common-weak.vue?vue&type=template&id=4f0504e8&scoped=true"
import script from "./exercise-common-weak.vue?vue&type=script&lang=js"
export * from "./exercise-common-weak.vue?vue&type=script&lang=js"
import style0 from "./exercise-common-weak.vue?vue&type=style&index=0&id=4f0504e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f0504e8",
  null
  
)

export default component.exports